import loadScript from 'load-script';

const dittoSDKVersion = '5.0.1';
function loadDitto(sdkUrl) {
    return window.Ditto || new Promise((resolve, reject)=>loadScript(sdkUrl, (err)=>err ? reject(err) : resolve(window.Ditto)
        )
    );
}
const dittoLocalesMap = {
    'nl-BE': 'nl-nl',
    'fr-BE': 'fr-fr',
    'en-IE': 'en-gb',
    'en-IO': 'pt-pt'
};
const getDittoLocale = (locale)=>{
    let dittoLocale = locale.toLowerCase();
    if (locale in dittoLocalesMap) {
        dittoLocale = dittoLocalesMap[locale];
    }
    return dittoLocale;
};
function createVtoServerConfig(publicRuntimeDittoConfig, locale) {
    const { apiUrl , partnerId , sdkUrl , accessKey , signatureRoute  } = publicRuntimeDittoConfig;
    const dittoLocale = getDittoLocale(locale);
    const composedSdkUrl = `${sdkUrl}/default/${dittoSDKVersion}/${dittoLocale}/api.js`;
    return {
        apiUrl,
        sdkUrl: composedSdkUrl,
        accessKey,
        partnerId,
        signatureRoute
    };
}
const vtoEvents = {
    'vto.view': ({ sku  })=>({
            eventAction: 'Available',
            eventLabel: `Product ${sku} - Available`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'vto available',
                    id: '000'
                }
            }
        })
    ,
    'vto.creation.view.intro': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Intro`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'introduction',
                    id: '100'
                }
            }
        })
    ,
    'vto.creation.view.camera': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Allow camera`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'allow camera',
                    id: '200'
                }
            }
        })
    ,
    'vto.creation.view.creation': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Creation`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'creation',
                    id: '300'
                }
            }
        })
    ,
    'vto.creation.view.record': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Record`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'record',
                    id: '400'
                }
            }
        })
    ,
    'vto.creation.view.save': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Save`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'save',
                    id: '500'
                }
            }
        })
    ,
    'vto.creation.success': ({ sku  })=>({
            eventAction: 'View',
            eventLabel: `Product ${sku} - Complete`,
            VTO: {
                configFlow: {
                    action: 'view step',
                    name: 'complete',
                    id: '600'
                }
            }
        })
    ,
    'vto.creation.error': ({ sku , status , description  })=>({
            eventAction: 'Failure',
            eventLabel: `Product ${sku} - Creation: error ${status}, ${description || ''}`,
            VTO: {
                configFlow: {
                    action: 'error',
                    name: status == 'CAMERA_BLOCKED' ? 'camera access' : 'creation failed'
                }
            }
        })
    ,
    'vto.tryon.open': ({ sku  })=>({
            eventAction: 'Open',
            eventLabel: `Product ${sku}`,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'open vto'
                }
            }
        })
    ,
    'vto.tryon.retake': ({ sku  })=>({
            eventAction: 'Retake',
            eventLabel: `Product ${sku}`,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'retake vto'
                }
            }
        })
    ,
    'vto.tryon.delete': ({ sku  })=>({
            eventAction: 'Delete',
            eventLabel: `Product ${sku}`,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'delete vto'
                }
            }
        })
    ,
    'vto.close': ({ sku  })=>({
            eventAction: 'Close',
            eventLabel: `Product ${sku}`,
            VTO: {
                configFlow: {
                    action: 'click',
                    name: 'close vto'
                }
            }
        })
};
const vtoEvent = (key, args)=>{
    if (!vtoEvents[key]) {
        console.warn(`cannot send event '${key}', key does not exist`);
        return;
    }
    const { eventAction , eventLabel , VTO  } = vtoEvents[key](args);
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'VTOevent',
            eventCategory: 'Virtual Try-On',
            eventAction,
            eventLabel,
            VTO
        });
    }
};

export { createVtoServerConfig, dittoSDKVersion, getDittoLocale, loadDitto, vtoEvent };
//# sourceMappingURL=utils.js.map
